var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.articles.length)?_c('div',{staticClass:"hdp-articles-list"},_vm._l((_vm.articles),function(article){return _c('div',{key:article.id,staticClass:"hdp-articles-item",on:{"click":function($event){_vm.$emit('route', {name: 'ArticleView', params: {articleId: article.id}})}}},[_vm._v(_vm._s(article.title))])})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd4f93a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticlesList.vue
// module id = null
// module chunks = 